import { ACTIVITY_UPLOAD_SUCCESS } from "constants/widgetConstants";

export function activityReducer(state = {}, action: any) {
  const { type, payload } = action;
  switch (type) {
    case ACTIVITY_UPLOAD_SUCCESS:
      return payload || state; 

    default:
      return state; 
  }
}